import StyledButton from 'app/components/StyledButton';
import StyledTable from 'app/components/StyledTable';
import { selectTranslations } from 'app/pages/App/slice/selectors';
import TooltipParagraph from 'app/pages/Catalog/tooltipParagraph';
import React from 'react';
import { useSelector } from 'react-redux';
import { formatNumber, formatTimeFrame, getFromDateToDate } from 'utils/helper';
import * as _ from 'lodash';
import { TICKET_TYPES } from 'utils/constants';

const ListRefundTicket = ({ dataSource, handleCancelTickets }) => {
  const translations = useSelector(selectTranslations);

  const columns = [
    {
      title: (
        <div style={{ textAlign: 'left', width: 300 }}>
          {translations?.['b2b.upgrade.ticket-name']}
        </div>
      ),
      dataIndex: 'productName',
      key: 'productName',
      render: value => (
        <>
          <TooltipParagraph
            ellipsis={{ rows: 2 }}
            style={{
              maxWidth: 300,
              marginBottom: 0,
              textAlign: 'left',
            }}
          >
            {!_.isEmpty(value) ? value.trim() : ''}
          </TooltipParagraph>
        </>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.park']}
        </div>
      ),
      dataIndex: 'park',
      key: 'park',
      render: value => (
        <>
          <TooltipParagraph
            ellipsis={{ rows: 1 }}
            style={{
              maxWidth: 300,
              marginBottom: 0,
              textAlign: 'left',
            }}
          >
            {!_.isEmpty(value?.name) ? value?.name.trim() : ''}
          </TooltipParagraph>
        </>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.ticket-type']}
        </div>
      ),
      dataIndex: 'catalog',
      key: 'catalog',
      render: value => <div style={{ textAlign: 'left' }}>{value?.name}</div>,
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.valid-from']}
        </div>
      ),
      key: 'dateFrom',
      render: value => {
        const firstValue = value?.tickets[0];
        const dataItem = { ...value, ticket: firstValue };
        const { fromDate } = getFromDateToDate(dataItem);
        return <div style={{ textAlign: 'left' }}>{fromDate}</div>;
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.valid-to']}
        </div>
      ),
      key: 'dateTo',
      render: value => {
        const firstValue = value?.tickets[0];
        const dataItem = { ...value, ticket: firstValue };
        const { toDate } = getFromDateToDate(dataItem);
        return <div style={{ textAlign: 'left' }}>{toDate}</div>;
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.upgrade.ticket-detail']}
        </div>
      ),
      key: 'detail',
      render: value => {
        const isCableTicket = value?.materialType === TICKET_TYPES.CABLE_CAR;
        const zone = value?.zone?.name;
        const restaurant = value?.restaurant?.name;
        const performance = formatTimeFrame(
          value?.product?.usedArea2Object?.label,
        );

        if (isCableTicket) return <div />;

        return (
          <div style={{ textAlign: 'left' }}>
            {zone && <div>{zone}</div>}
            {restaurant && <div>{restaurant}</div>}
            {performance && <div>{performance}</div>}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'right' }}>
          {translations?.['b2b.upgrade.ticket-amount']}
        </div>
      ),
      dataIndex: 'amount',
      key: 'amount',
      render: value => <div style={{ textAlign: 'right' }}>{value}</div>,
    },
    {
      title: (
        <div style={{ textAlign: 'right' }}>
          {translations?.['b2b.upgrade.bill']}
        </div>
      ),
      dataIndex: 'originalPrice',
      key: 'originalPrice',
      render: value => (
        <div style={{ textAlign: 'right' }}>
          {`${formatNumber(value).replaceAll(',', '.')}đ`}
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'right' }}>
          {translations?.['b2b.upgrade.total-bill']}
        </div>
      ),
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      render: value => (
        <div style={{ textAlign: 'right' }}>
          {`${formatNumber(value).replaceAll(',', '.')}đ`}
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'right' }}>
          {translations?.['b2b.upgrade.refun-percent']}
        </div>
      ),
      dataIndex: 'exchangeRate',
      key: 'exchangeRate',
      render: value => (
        <div style={{ textAlign: 'right' }}>{Number(value) + '%'}</div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'right' }}>
          {translations?.['b2b.upgrade.refund-fee']}
        </div>
      ),
      dataIndex: 'exchangeCharge',
      key: 'exchangeCharge',
      render: value => (
        <div style={{ textAlign: 'right' }}>
          {`${formatNumber(Number(value)).replaceAll(',', '.')}đ`}
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'center' }}>
          {translations?.['b2b.upgrade.action']}
        </div>
      ),
      key: 'action',
      render: value => {
        return (
          <StyledButton
            disabled={!(dataSource?.length > 1 && !!value?.id)}
            bgColor="white"
            border="1px solid #F8B117"
            textColor="#F8B117"
            height={'38px'}
            width={'100%'}
            onClick={() =>
              handleCancelTickets && handleCancelTickets(value?.id)
            }
          >
            {translations?.['b2b.btn.unchecked']}
          </StyledButton>
        );
      },
    },
  ];

  return (
    <StyledTable dataSource={dataSource} columns={columns} pagination={false} />
  );
};

export default ListRefundTicket;
